'use client';

import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <>
      {isVisible && (
        <button data-component-id="src/components/ui/ScrollToTop.jsx:33:8" data-component-path="src/components/ui/ScrollToTop.jsx" data-component-line="33" data-component-end-line="52" data-component-file="ScrollToTop.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20bottom-6%20right-6%20bg-primary%20hover%3Abg-primary-light%20text-white%20p-3%20rounded-full%20shadow-lg%20transition-all%20z-50%22%7D"
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-primary hover:bg-primary-light text-white p-3 rounded-full shadow-lg transition-all z-50"
          aria-label="Scroll to top"
        >
          <svg data-component-id="src/components/ui/ScrollToTop.jsx:38:10" data-component-path="src/components/ui/ScrollToTop.jsx" data-component-line="38" data-component-end-line="51" data-component-file="ScrollToTop.jsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22h-5%20w-5%22%7D" 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path data-component-id="src/components/ui/ScrollToTop.jsx:45:12" data-component-path="src/components/ui/ScrollToTop.jsx" data-component-line="45" data-component-end-line="50" data-component-file="ScrollToTop.jsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M5 15l7-7 7 7" 
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
